/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.span`
	${({flex}) => flex
    ? `
		display:flex;
		align-items: center;
		`
    : null
    }
	font-size: ${({big, small}) => big
    ? '22px'
    : small
        ? '14px'
        : 'inherit'
    };
	letter-spacing: -0.02em;
	font-weight: 500;
`;


// WEBPACK FOOTER //
// ./src/components/task/shop/text.js